<template>
  <AppLayout>
    <Head title="Subscription Status" />
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        Subscription Status
      </h2>
    </template>

    <div class="max-w-4xl mx-auto mt-6">
        <div class="bg-white shadow sm:rounded-lg px-6 py-8 text-gray-700 mt-4 space-y-4">
        
            <div>Subscription status:
                <span class="font-semibold text-gray-900">
                    {{ statusLabel }}
                </span>
            </div>
            <div>
                Access is limited for team members while the subscription is {{ statusLabel.toLowerCase() }}.
            </div>

            <div>
                Please contact the account owner
                <span class="font-semibold text-gray-900">{{ props.owner.name }}</span>
                for assistance.
            </div>
        </div>
    </div>
  </AppLayout>
</template>

<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import { Head } from '@inertiajs/vue3';
import { computed } from 'vue';

const props = defineProps({
  owner: {
    type: Object,
    default: () => ({ name: '', email: '' }),
  },
  status: {
    type: String,
    default: '',
  },
});


const statusLabel = computed(() => {
  if (props.status === 'paused') {
    return 'Paused';
  }
  if (props.status === 'inactive') {
    return 'Inactive';
  }
  return 'Unavailable';
});
</script>
